import { default as getCookie } from "@pb/utils/getCookie";
const getDataFromUserCookie = () => {
    const cookieObject = getCookie('userCookie');
    if (!cookieObject) {
        return {};
    }
    const { bpid, customer_key: customerKey } = JSON.parse(cookieObject);
    return {
        bpid,
        customerKey,
    };
};
export default getDataFromUserCookie;
//# sourceMappingURL=getDataFromUserCookie.js.map